import { render, staticRenderFns } from "./addPlan.vue?vue&type=template&id=1ca5ff5d&lang=true"
import script from "./addPlan.vue?vue&type=script&lang=js"
export * from "./addPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports